<template>
  <v-app>
    <Loading />
    <Agency />
  </v-app>
</template>

<script>
import Agency from '@/pages/agency/Main';
import Loading from '@/components/organisms/common/Loading';

export default {
  name: 'App',
  components: {
    Agency,
    Loading,
  },
  data: () => ({}),
  methods: {},
};
</script>

<style lang="scss">
@import '@/styles/index.scss';
</style>

<!-- グローバルスタイル（SCSS をバイパスして直接適用） -->
<style>
/*
 * Vuetify 3: VDataTableFooter は showFirstLastPage:true をハードコード済みのため
 * :show-first-last-page="false" プロパティは VDataTable に存在せず無効。
 * CSS で全データテーブルのページネーション最初・最後ページボタンを非表示にする。
 * 対象: #82 (保険種別一覧), #86 (重要事項等説明書一覧), #88 (ユーザー一括登録/更新確認) 他全テーブル
 */
.v-data-table-footer .v-pagination__first,
.v-data-table-footer .v-pagination__last {
  display: none;
}
</style>

<style>
/* v-data-table ヘッダー背景色（Vuetify 3 対応） */
.v-data-table thead tr th,
.v-data-table .v-data-table-column--fixed-pinned,
.v-table thead tr th {
  background-color: #E3F2FD !important;
}

/* v-btn variant のデフォルトが効かない場合の補完 */
.v-app-bar .v-btn[color="next"],
.v-app-bar .v-btn.bg-next {
  background-color: rgb(var(--v-theme-next)) !important;
  color: white !important;
}
</style>

<style>
/* AsIs v-data-table-header の背景色を Vuetify 3 でも再現 */
/* rgb(150, 200, 240) = Vuetify 2 デフォルトのテーブルヘッダー色 */
.v-data-table thead,
.v-table thead {
  background-color: rgb(150, 200, 240) !important;
}
.v-data-table thead tr,
.v-data-table thead th,
.v-table thead tr,
.v-table thead th {
  background-color: rgb(150, 200, 240) !important;
}
</style>
